<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Título y breadcrumb -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/plantilla">Plantillas</router-link>
            &gt; {{ datoPlantilla.nombre || 'Nueva Plantilla' }}
          </div>
        </div>
        <div class="col-1 text-end">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: #0d6efd; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>

    <hr />

    <!-- Sección Master (Información de la Plantilla) -->
    <div class="card mb-4">
      <div class="card-header bg-light">
        <h5 class="mb-0">Información de la Plantilla</h5>
      </div>
      <div class="card-body">
        <form>
          <div class="row g-3">
            <div class="col-md-2">
              <label for="idPlantilla" class="form-label fw-bold">ID</label>
              <input
                type="text"
                class="form-control"
                id="idPlantilla"
                v-model="datoPlantilla.idPlantilla"
                disabled
              />
            </div>
            <div class="col-md-10">
              <label for="nombre" class="form-label fw-bold">Nombre de la Plantilla</label>
              <input
                type="text"
                class="form-control"
                id="nombre"
                v-model="datoPlantilla.nombre"
                style="text-transform: uppercase"
                required
              />
            </div>
          </div>
        </form>
      </div>
      <div class="card-footer text-end">
        <button
          v-if="btnCrear"
          class="btn btn-success me-2"
          @click.prevent="guardarPlantilla"
        >
          <i class="material-icons" style="font-size: 20px">save</i> Guardar
        </button>
        <button
          v-if="btnEditar"
          class="btn btn-primary"
          @click.prevent="actualizarPlantilla"
        >
          <i class="material-icons" style="font-size: 20px">update</i> Actualizar
        </button>
      </div>
    </div>

    <!-- Barra de acciones para detalles -->
    <div class="row g-2 align-items-center mb-3">
      <div class="col-auto">
        <button
          class="btn btn-success btn-sm d-flex align-items-center gap-1"
          data-bs-toggle="modal"
          data-bs-target="#ventanaModal"
          @click="abrirModalCrear"
        >
          <span class="material-icons" style="font-size: 18px">add_box</span>
          Nuevo registro
        </button>
      </div>

      <div class="col-auto ms-auto">
        <div class="d-flex gap-2 align-items-center">
          <input type="file" accept=".csv" @change="handleFileChange" class="form-control form-control-sm" style="width: 220px" />
          <button
            class="btn btn-outline-success btn-sm"
            @click="uploadFile"
            :disabled="!selectedFile"
          >
            <span class="material-icons" style="font-size: 18px">upload</span>
            Cargar CSV
          </button>
        </div>
      </div>
    </div>

    <!-- Tabla de Detalles -->
    <div class="table-responsive">
      <table class="table table-hover table-bordered table-sm" id="sampleTable">
        <thead class="table-dark">
          <!-- Encabezados -->
          <tr>
            <th style="width: 50px"></th>
            <th>Código</th>
            <th>Nombre: examen / procedimiento / medicamento / insumo</th>
            <th style="width: 120px">Cantidad</th>
            <th style="width: 80px">Acciones</th>
          </tr>
          <!-- Fila de filtros (opcional - puedes activarlo después) -->
          <!-- <tr>
            <th></th>
            <th><input class="form-control form-control-sm" placeholder="Filtrar código..." /></th>
            <th><input class="form-control form-control-sm" placeholder="Filtrar nombre..." /></th>
            <th></th>
            <th></th>
            <th></th>
          </tr> -->
        </thead>
        <tbody>
          <tr v-for="det in datosPaginados" :key="det.idPlantillaDet">
            <td class="text-center">
              <i
                class="material-icons"
                style="font-size: 18px; color: #fd7e14; cursor: pointer"
                @click="abrirModalEditar(det.idPlantillaDet)"
                title="Editar"
              >
                edit_square
              </i>
            </td>
            <td>{{ det.elementoCodigo }}</td>
            <td>{{ det.elementoNombre }}</td>
            <td class="text-center">{{ det.cantidad }}</td>
            <td class="text-center">
              <i
                class="material-icons"
                style="font-size: 18px; color: #dc3545; cursor: pointer"
                @click="deletePlantillaDet(det.idPlantillaDet)"
                title="Eliminar"
              >
                delete
              </i>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="plantilladets.length > 0">
          <tr class="table-secondary">
            <td colspan="6" class="text-end fw-bold small">
              Mostrando {{ datosPaginados.length }} de {{ plantilladets.length }} registros
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- Mensaje sin resultados -->
    <div v-if="plantilladets.length === 0" class="alert alert-warning mt-3">
      No se encontraron registros para esta plantilla.
    </div>

    <!-- Paginación mejorada -->
    <div class="d-flex justify-content-between align-items-center mt-3" v-if="plantilladets.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas() }}
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="getPreviousPage">‹</a>
          </li>
          <li
            v-for="pagina in paginasVisibles"
            :key="pagina"
            class="page-item"
            :class="{ active: pagina === paginaActual }"
          >
            <a class="page-link" href="#" @click.prevent="getDataPaginaTodos(pagina)">{{ pagina }}</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas() }">
            <a class="page-link" href="#" @click.prevent="getNextPage">›</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Modal para Crear/Editar Detalle -->
    <div class="modal fade" id="ventanaModal" tabindex="-1" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <!-- Campo de búsqueda de Elemento -->
            <div class="mb-3">
              <label class="form-label fw-bold">Elemento</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="searchTextElemento"
                  @input="filterElementos"
                  @focus="showDropdownElemento = true"
                  placeholder="Buscar por código o nombre..."
                />
                <ul
                  class="dropdown-menu shadow w-100"
                  :class="{ show: showDropdownElemento }"
                  style="max-height: 300px; overflow-y: auto"
                >
                  <li v-for="el in filteredElementos" :key="el.idElemento">
                    <a class="dropdown-item" href="#" @mousedown.prevent="selectElemento(el)">
                      <strong>({{ el.clasElemNombre }})</strong> — {{ el.codigo }} — {{ el.nombre }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Cantidad -->
            <div class="mb-3">
              <label class="form-label fw-bold">Cantidad</label>
              <input
                type="number"
                class="form-control"
                v-model="datoPlantillaDet.cantidad"
                min="1"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              v-if="btnCrear_det"
              class="btn btn-success"
              @click.prevent="guardarPlantillaDet"
            >
              <i class="material-icons">save</i> Guardar
            </button>
            <button
              v-if="btnEditar_det"
              class="btn btn-primary"
              @click.prevent="actualizarPlantillaDet"
            >
              <i class="material-icons">update</i> Actualizar
            </button>
            <button class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Layout from "../../components/Layout.vue";
import Footer from "../../components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import Swal from "sweetalert2";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      // Variables master
      plantillas: [],
      datoPlantilla: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      p_idPlantilla: "",
      // Variables master
      showModalHelp: false,
      searchTextElemento: "",
      filteredElementos: [],
      showDropdownElemento: false,
      // Variables details
      plantilladets: [],
      datoPlantillaDet: {},
      nombreBusqueda_det: "",
      titulo_det: "",
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      elementos: [],
      modalWindow: true,
      selectedFile: null,
      // Variables details
    };
  },
  mounted() {
    this.p_idPlantilla = this.$route.params.p_idplantilla;
    this.abrirEditar(this.p_idPlantilla);
    this.getDataPaginaTodos(1);
    this.fetchElementos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    // Procedimientos master
    validarForm() {
      const requiredFields = ["nombre"];
      const requiredFieldsText = ["nombre"];
      return validarForm(
        this.datoPlantilla,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarPlantilla() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/plantillas",
            this.datoPlantilla
          );
Swal.fire({
  icon: 'success',
  title: 'Correcto!',
  text: 'PlantillaDet creada exitosamente!',
  confirmButtonText: 'Aceptar'
});		  
        } catch (error) {
Swal.fire({
  icon: 'error',
  title: 'Error!',
  text: 'Inténtelo de nuevo!',
  confirmButtonText: 'Cerrar'
});        }
      }
    },
    async actualizarPlantilla() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/plantillas",
            this.datoPlantilla
          );
Swal.fire({
  icon: 'success',
  title: 'Correcto!',
  text: 'Plantilla creado(a) exitosamente!',
  confirmButtonText: 'Aceptar'
});
        } catch (error) {
Swal.fire({
  icon: 'error',
  title: 'Error!',
  text: 'Inténtelo de nuevo!',
  confirmButtonText: 'Cerrar'
});
          var array = Object.values(error.response.data.errors);
array.forEach((element) => {
  Swal.fire({
    icon: 'warning',
    title: 'Aviso',
    text: String(element),
    confirmButtonText: 'Siguiente'
  });
});
        }
      }
    },
    abrirCrear() {
      this.modalWindow = true;
      this.datoPlantilla = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirEditar(idPlantilla) {
      this.modalWindow = true;
      if (idPlantilla != null) {
        api.get("/vwplantillas/" + idPlantilla)
          .then((resp) => {
            this.datoPlantilla = resp.data;
          });
      }
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    cerrarPlantilla() {
      this.$router.push("/Plantilla");
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.plantilladets.length / this.elementosPorPagina);
    },
    /*	
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwplantilladets/idplantilla/" +
              this.p_idPlantilla +
              "?nombre=" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.plantilladets = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.plantilladets.slice(ini, fin);
          });
      }
    },
*/
    getDataPaginaTodos(noPagina) {
      api.get("/vwplantilladets/idplantilla/" +
            this.p_idPlantilla
        )
        .then((response) => {
          this.plantilladets = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.plantilladets.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPaginaTodos(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarFormDet() {
      const requiredFields = ["nombre"];
      const requiredFieldsText = ["nombre"];
      return validarForm(
        this.datoPlantilla,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarPlantillaDet() {
      if (this.validarForm() === 1) {
        try {
          this.datoPlantillaDet.idPlantilla = this.datoPlantilla.idPlantilla;
          await api.post("/plantilladets",
            this.datoPlantillaDet
          );
          $("#ventanaModal").modal("hide");
Swal.fire({
  icon: 'success',
  title: 'Correcto!',
  text: 'PlantillaDet creada exitosamente!',
  confirmButtonText: 'Aceptar'
});
          this.getDataPaginaTodos(this.paginaActual);
        } catch (error) {
Swal.fire({
  icon: 'error',
  title: 'Error!',
  text: 'Inténtelo de nuevo!',
  confirmButtonText: 'Cerrar'
});		  
        }
      }
    },
    async actualizarPlantillaDet() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/plantilladets",
            this.datoPlantillaDet
          );
          $("#ventanaModal").modal("hide");
          this.getDataPaginaTodos(this.paginaActual);
Swal.fire({
  icon: 'success',
  title: 'Correcto!',
  text: 'PlantillaDet creado(a) exitosamente!',
  confirmButtonText: 'Aceptar'
});		  
        } catch (error) {
Swal.fire({
  icon: 'error',
  title: 'Error!',
  text: 'Inténtelo de nuevo!',
  confirmButtonText: 'Cerrar'
});	
          var array = Object.values(error.response.data.errors);
array.forEach((element) => {
  Swal.fire({
    icon: 'warning',
    title: 'Aviso',
    text: String(element),
    confirmButtonText: 'Siguiente'
  });
});		  
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPlantillaDet = {};
      this.titulo = "Crear ";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
      this.searchTextElemento = "";
      this.searchTextExamen = "";
    },
    abrirModalEditar(idPlantillaDet) {
      this.modalWindow = true;
      if (idPlantillaDet != null) {
        api.get("/vwplantilladets/" + idPlantillaDet)
          .then((resp) => {
            this.datoPlantillaDet = resp.data;
            this.searchTextElemento =
              this.datoPlantillaDet.elementoCodigo +
              " - " +
              this.datoPlantillaDet.elementoNombre;
            this.searchTextExamen = this.datoPlantillaDet.examenNombre;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
    },
    abrirEditarDet(idPlantillaDet) {
      this.modalWindow = true;
      if (idPlantillaDet != null) {
        this.$router.push("/plantilladetmd/" + idPlantillaDet);
      }
    },
    async deletePlantillaDet(idPlantillaDet) {
      try {
        await api.delete("/plantilladets/" + idPlantillaDet
        );
        this.getDataPaginaTodos(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    // Procedimientos detalle
fetchElementos() {
  api.get('/vwelementos')
    .then(response => {
      this.elementos = response.data;
    })
    .catch(error => {
      console.error('Error fetching elementos:', error);
    });
},

    // Ocultar dropdown al perder el foco
    hideDropdown(type) {
      setTimeout(() => {
        if (type === "Elemento") this.showDropdownElemento = false;
      }, 200); // Agrega un retraso para permitir el evento click
    },

    // Filtrar elementos
    /*	
    filterElementos() {
      this.filteredElementos = this.elementos.filter((elemento) =>
        elemento.nombre
          .toLowerCase()
          .includes(this.searchTextElemento.toLowerCase())
      );
    },
*/
    filterElementos() {
      const search = this.searchTextElemento.toLowerCase();
      this.filteredElementos = this.elementos.filter((elemento) =>
        `${elemento.codigo} ${elemento.nombre}`.toLowerCase().includes(search)
      );
    },

    // Seleccionar un elemento del dropdown
    selectElemento(elemento) {
      this.datoPlantillaDet.idElemento = elemento.idElemento;
      this.searchTextElemento = elemento.nombre;
      this.showDropdownElemento = false; // Ocultar el dropdown
    },
	
// --- Helpers de SweetAlert2 ---

    showSuccessAlert(message) {
      Swal.fire({
        icon: 'success',
        title: '¡Carga Exitosa!',
        text: message,
        confirmButtonText: 'Aceptar'
      });
    },

    showErrorAlert(message) {
      Swal.fire({
        icon: 'error',
        title: 'Error de Carga',
        html: message,
        confirmButtonText: 'Cerrar'
      });
    },

    // --- Manejadores de Eventos ---

    /**
     * Captura el archivo seleccionado por el usuario y lo almacena en 'selectedFile'.
     */
    handleFileChange(event) {
      this.selectedFile = event.target.files[0];
    },

    /**
     * Prepara la solicitud HTTP y la envía al backend.
     */
    async uploadFile() {
      // 1. Validaciones
      if (!this.selectedFile || this.idPlantilla === null) {
        this.showErrorAlert('Por favor, selecciona un archivo y proporciona un ID de Plantilla.');
        return;
      }
      
      // 2. Preparar FormData
      const formData = new FormData();
      formData.append('file', this.selectedFile); 
      
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data' 
        }
      };
      
      // 3. Mostrar Alerta de Carga (Loading)
      Swal.fire({
        title: 'Cargando archivo...',
        text: 'Por favor, espera. La carga está en progreso.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // 4. Petición HTTP con Axios
      try {
        const response = await api.post(
          `/cargaplantilladets/upload?idPlantilla=${this.p_idPlantilla}`, // URL con el parámetro idPlantilla
          formData,
          config
        );

        // 5. Éxito
        Swal.close();
        this.showSuccessAlert(response.data.message);

        this.getDataPaginaTodos(1);

      } catch (error) {
        // 6. Error
        Swal.close();
        
        // Obtener el mensaje de error del backend
        const errorMessage = error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'Error de red o del servidor al cargar el archivo.';
          
        this.showErrorAlert(errorMessage);
        console.error('Error durante la subida:', error);
      }
    }	
  },
};
</script>
